import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import CloseIcon from '@mui/icons-material/Close'
import {StyledDialog, StyledIconButton} from './Styles'
import PropTypes from 'prop-types'

const CustomDialog = ({
  open,
  title,
  content,
  actions,
  handleClose,
  showCloseBtn = true,
  disableCloseBtn = false,
  timelineDialog = false,
  showDivider = true,
  maxWidth = 'sm',
  categorizeInterestTags = false,
  isZIndexReqired = false
}) => {
  return (
    <StyledDialog
      aria-labelledby="custom-dialog-title"
      open={open}
      onClose={handleClose}
      timelineDialog={timelineDialog}
      maxWidth={maxWidth}
      zIndexRequired={isZIndexReqired}
      fullWidth
    >
      {title && <DialogTitle id="custom-dialog-title">{title}</DialogTitle>}
      {showCloseBtn && (
        <StyledIconButton
          sx={{margin: categorizeInterestTags && '20px'}}
          aria-label="close"
          onClick={handleClose}
          disabled={disableCloseBtn}
        >
          <CloseIcon />
        </StyledIconButton>
      )}
      {content && <DialogContent dividers={showDivider}>{content}</DialogContent>}
      {actions && <DialogActions>{actions}</DialogActions>}
    </StyledDialog>
  )
}

CustomDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.element,
  content: PropTypes.element.isRequired,
  actions: PropTypes.element,
  showCloseBtn: PropTypes.bool,
  disableCloseBtn: PropTypes.bool,
  handleClose: PropTypes.func,
  timelineDialog: PropTypes.bool,
  showDivider: PropTypes.bool,
  maxWidth: PropTypes.string,
  categorizeInterestTags: PropTypes.bool,
  isZIndexReqired: PropTypes.bool
}

export default CustomDialog
